import { useState, useEffect } from 'react';

export default function Home() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const testimonials = [
    {
      name: "Parent Testimonial",
      child: "Anonymous Parent",
      text: "Ms Fortunate taught my son and made significant positive impact on both his academic progress & personal development"
    },
    {
      name: "Parent Testimonial", 
      child: "Anonymous Parent",
      text: "As a parent of a child with ADHD, finding CogniHeroes was a blessing. The progress has been remarkable & the support incredible"
    },
    {
      name: "Parent Testimonial",
      child: "Anonymous Parent", 
      text: "Ms F. is patient, creative, and highly attentive to the individual needs of her learners. Her communication with parents is always respectful and supportive, fostering strong collaboration for each child's development."
    }
  ];

  // Add Schema.org JSON-LD for home page
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "CogniHeroes Academy - Home",
      "description": "Empowering minds through inclusive neurofeedback training and cognitive development programs for children with autism, ADHD, and learning differences.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "mainEntity": {
        "@type": "EducationalOrganization",
        "name": "CogniHeroes Academy",
        "description": "CogniHeroes Academy provides inclusive neurofeedback training and cognitive development programs for children with autism, ADHD, and learning differences in South Africa.",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
        "logo": "https://static.readdy.ai/image/9173bb0b0f2f56000757a7cf45758267/1ea37a87bc1fe065fa3e33c05120ca7c.png",
        "image": "https://static.readdy.ai/image/9173bb0b0f2f56000757a7cf45758267/1ea37a87bc1fe065fa3e33c05120ca7c.png",
        "telephone": "+27 69 423 8367",
        "email": "cogniheroesacademy@gmail.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "West Acres",
          "addressLocality": "Mbombela",
          "addressRegion": "Mpumalanga",
          "postalCode": "1200",
          "addressCountry": "ZA"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": -25.4753,
          "longitude": 30.9698
        },
        "areaServed": {
          "@type": "Country",
          "name": "South Africa"
        },
        "serviceType": [
          "Neurofeedback Training",
          "Cognitive Development",
          "Autism Support",
          "ADHD Treatment",
          "Learning Differences Support",
          "Social-Emotional Learning"
        ],
        "sameAs": [
          "https://www.facebook.com/share/1AX5Ghv27A/?mibextid=wwXIfr",
          "https://www.instagram.com/cogniheroesacademy?igsh=MWVkZzFneWJ0MndrYw%3D%3D&utm_source=qr",
          "https://www.tiktok.com/@cogniheroes.acade?_r=1&_t=ZS-91ObP0zBoT2"
        ],
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "08:00",
          "closes": "18:00"
        },
        "priceRange": "R300 - R1500",
        "paymentAccepted": "Cash, Bank Transfer",
        "currenciesAccepted": "ZAR"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
          }
        ]
      }
    });
    document.head.appendChild(script);

    // Add FAQ Schema
    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is neurofeedback training?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Neurofeedback training uses advanced neural training techniques to enhance focus and cognitive function in children with learning differences."
          }
        },
        {
          "@type": "Question", 
          "name": "What age groups do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We provide specialized programs for children aged 5-18 years with neurodivergent profiles, including autism spectrum disorder, ADHD, and dyslexia."
          }
        },
        {
          "@type": "Question",
          "name": "How much does a consultation cost?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our comprehensive initial consultation and assessment costs R300, which includes cognitive evaluation and personalized program design."
          }
        }
      ]
    });
    document.head.appendChild(faqScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(faqScript);
    };
  }, []);

  const scrollToBooking = () => {
    const bookingSection = document.getElementById('booking-section');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about-section');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const scrollToTestimonials = () => {
    const testimonialsSection = document.getElementById('testimonials-section');
    if (testimonialsSection) {
      testimonialsSection.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const scrollToMeetMs = () => {
    const meetMsSection = document.getElementById('meet-ms-section');
    if (meetMsSection) {
      meetMsSection.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-stone-50" style={{ fontFamily: '"Inter", sans-serif' }}>
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-amber-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/9173bb0b0f2f56000757a7cf45758267/1ea37a87bc1fe065fa3e33c05120ca7c.png" 
                alt="CogniHeroes Academy Logo" 
                className="h-10 w-10"
              />
              <h1 className="text-2xl font-bold text-amber-900" style={{ fontFamily: '"Playfair Display", serif' }}>
                CogniHeroes Academy
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-amber-900 hover:text-orange-700 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer">Home</a>
                <button onClick={scrollToAbout} className="text-amber-800 hover:text-orange-700 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer">About</button>
                <button onClick={scrollToTestimonials} className="text-amber-800 hover:text-orange-700 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer">Testimonials</button>
                <button onClick={scrollToContact} className="text-amber-800 hover:text-orange-700 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer">Contact</button>
                <button 
                  onClick={scrollToBooking}
                  className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
                >
                  Book Session
                </button>
              </div>
            </div>
            <div className="md:hidden">
              <button 
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-amber-900 hover:text-orange-700 cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
                </div>
              </button>
            </div>
          </div>
          
          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden pb-4">
              <div className="flex flex-col space-y-2">
                <a href="/" className="text-amber-900 hover:text-orange-700 px-3 py-2 text-sm font-medium cursor-pointer">Home</a>
                <button onClick={scrollToAbout} className="text-amber-800 hover:text-orange-700 px-3 py-2 text-sm font-medium text-left cursor-pointer">About</button>
                <button onClick={scrollToTestimonials} className="text-amber-800 hover:text-orange-700 px-3 py-2 text-sm font-medium text-left cursor-pointer">Testimonials</button>
                <button onClick={scrollToContact} className="text-amber-800 hover:text-orange-700 px-3 py-2 text-sm font-medium text-left cursor-pointer">Contact</button>
                <button 
                  onClick={scrollToBooking}
                  className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors text-center"
                >
                  Book Session
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/df5806aab60d331eed9bc22515693941.jpg')`
        }}
      >
        <div className="text-center text-white px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Empowering Minds, Nurturing Focus
          </h1>
          <p className="text-xl md:text-2xl mb-12 leading-relaxed">
            Inclusive education dedicated to providing holistic learning experiences.
          </p>
          <button 
            onClick={scrollToBooking}
            className="bg-white text-orange-700 px-12 py-4 rounded-full text-lg font-semibold whitespace-nowrap cursor-pointer hover:bg-orange-50 transition-colors shadow-xl"
          >
            Book a Session
          </button>
        </div>
      </section>

      {/* About Summary */}
      <section id="about-section" className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-amber-900 mb-8" style={{ fontFamily: '"Playfair Display", serif' }}>Where Every Child's Special Power Shines</h2>
            <p className="text-lg text-stone-700 leading-relaxed max-w-4xl mx-auto">
              The Academy tailors its instructional approach to meet each child's unique cognitive, emotional, and developmental needs. We offer specialized developmental programs for children with neurodivergent profiles, including those with learning differences such as autism spectrum disorder, ADHD, and dyslexia. Our curriculum integrates cognitive development, social-emotional learning, and practical life skills to ensure that every learner reaches their fullest potential. Through evidence-based teaching methods and a nurturing environment, CogniHeroes Academy empowers each child to discover and strengthen their unique abilities—where every child's special power truly shines.
            </p>
          </div>
        </div>
      </section>

      {/* Highlights Section */}
      <section className="py-24 bg-stone-50 relative">
        {/* Watermark Logo */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <img 
            src="https://static.readdy.ai/image/9173bb0b0f2f56000757a7cf45758267/1ea37a87bc1fe065fa3e33c05120ca7c.png" 
            alt="CogniHeroes Academy Watermark" 
            className="w-96 h-96 opacity-5"
          />
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-brain-line text-4xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-amber-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                Neurofeedback Training
              </h3>
              <p className="text-stone-600 leading-relaxed">
                Advanced neural training techniques to enhance focus and cognitive function
              </p>
            </div>
            <div className="text-center bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-emotion-line text-4xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-amber-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                Social-Emotional Learning
              </h3>
              <p className="text-stone-600 leading-relaxed">
                Building emotional intelligence and social skills for lifelong success
              </p>
            </div>
            <div className="text-center bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-graduation-cap-line text-4xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-amber-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                Holistic Education Programs
              </h3>
              <p className="text-stone-600 leading-relaxed">
                Comprehensive learning approaches tailored to individual needs
              </p>
            </div>
            <div className="text-center bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-4xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-amber-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                Inclusive & Supportive Environment
              </h3>
              <p className="text-stone-600 leading-relaxed">
                A nurturing space where every child feels valued and understood
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Slider */}
      <section id="testimonials-section" className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-5xl font-bold text-amber-900 text-center mb-16" style={{ fontFamily: '"Playfair Display", serif' }}>What Parents Say</h2>
          <div className="relative bg-stone-50 rounded-3xl p-8 md:p-12">
            <div className="text-center">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-8">
                <i className="ri-double-quotes-l text-4xl text-orange-600"></i>
              </div>
              <p className="text-xl text-stone-700 mb-8 leading-relaxed italic">
                "{testimonials[currentTestimonial].text}"
              </p>
              <div className="text-amber-900">
                <p className="font-semibold text-lg">{testimonials[currentTestimonial].name}</p>
                <p className="text-stone-600">{testimonials[currentTestimonial].child}</p>
              </div>
            </div>
            <button 
              onClick={() => setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-14 h-14 bg-white rounded-full shadow-lg hover:shadow-xl flex items-center justify-center cursor-pointer transition-all"
            >
              <i className="ri-arrow-left-line text-xl text-amber-900"></i>
            </button>
            <button 
              onClick={() => setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-14 h-14 bg-white rounded-full shadow-lg hover:shadow-xl flex items-center justify-center cursor-pointer transition-all"
            >
              <i className="ri-arrow-right-line text-xl text-amber-900"></i>
            </button>
          </div>
          <div className="flex justify-center mt-8 space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-4 h-4 rounded-full cursor-pointer transition-colors ${
                  index === currentTestimonial ? 'bg-orange-600' : 'bg-orange-200'
                }`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section id="booking-section" className="py-24 bg-gradient-to-br from-orange-600 via-amber-600 to-orange-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold text-white mb-8" style={{ fontFamily: '"Playfair Display", serif' }}>Start Your Child's Journey Today</h2>
          <p className="text-xl text-orange-100 mb-12 leading-relaxed">
            Book your child's first consultation for R300 — includes assessment and personalized plan.
          </p>
          <div className="flex justify-center">
            <a 
              href="/booking"
              className="bg-white text-orange-700 px-10 py-4 rounded-full text-lg font-semibold whitespace-nowrap cursor-pointer hover:bg-orange-50 transition-colors shadow-xl"
              onClick={() => {
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
              }}
            >
              Register Now
            </a>
          </div>
        </div>
      </section>

      {/* Meet Ms Fortunate Section */}
      <section id="meet-ms-section" className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-amber-900 mb-8" style={{ fontFamily: '"Playfair Display", serif' }}>Meet Ms Fortunate</h2>
            <p className="text-lg text-stone-700 leading-relaxed max-w-3xl mx-auto">
              Get to know the passionate practitioner behind CogniHeroes Academy
            </p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="space-y-6">
                <div className="bg-stone-50 p-8 rounded-2xl">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-brain-line text-2xl text-orange-600"></i>
                    </div>
                    <h3 className="text-xl font-semibold text-amber-900" style={{ fontFamily: '"Playfair Display", serif' }}>
                      Professional Expertise
                    </h3>
                  </div>
                  <p className="text-stone-700 leading-relaxed">
                    Ms Fortunate is a dedicated neurofeedback and behaviour practitioner with a deep passion for empowering children with diverse learning needs. As a proud University of Mpumalanga alumni, she combines academic excellence with practical expertise.
                  </p>
                </div>

                <div className="bg-stone-50 p-8 rounded-2xl">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-award-line text-2xl text-orange-600"></i>
                    </div>
                    <h3 className="text-xl font-semibold text-amber-900" style={{ fontFamily: '"Playfair Display", serif' }}>
                      Specialized Certifications
                    </h3>
                  </div>
                  <p className="text-stone-700 leading-relaxed">
                    Driven by her love and passion for helping children, Ms Fortunate has gone above and beyond to acquire additional certifications from prestigious institutions including the Epilepsy Foundation and the Aldeia Neurofeedback Institute, among others.
                  </p>
                </div>

                <div className="bg-stone-50 p-8 rounded-2xl">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-lightbulb-line text-2xl text-orange-600"></i>
                    </div>
                    <h3 className="text-xl font-semibold text-amber-900" style={{ fontFamily: '"Playfair Display", serif' }}>
                      Leadership & Innovation
                    </h3>
                  </div>
                  <p className="text-stone-700 leading-relaxed">
                    Beyond her clinical expertise, Ms Fortunate has developed extensive managerial and entrepreneurial skills, enabling her to create and lead CogniHeroes Academy with vision and compassion. Her holistic approach ensures every child receives personalized care and attention.
                  </p>
                </div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="relative">
                <div className="bg-gradient-to-br from-orange-100 to-amber-100 rounded-3xl p-8">
                  <img 
                    src="https://static.readdy.ai/image/9173bb0b0f2f56000757a7cf45758267/4434caffef3e56f8cf8393cfb233a165.jpeg" 
                    alt="Ms Fortunate - Neurofeedback and Behaviour Practitioner" 
                    className="w-full h-96 object-cover object-top rounded-2xl shadow-lg"
                  />
                </div>
                <div className="mt-8 bg-gradient-to-r from-orange-50 to-amber-50 p-6 rounded-2xl">
                  <blockquote className="text-lg text-stone-700 italic leading-relaxed text-center">
                    "Every child has unique potential waiting to be unlocked. My mission is to provide the tools, support, and nurturing environment needed for each child to discover their special powers and thrive."
                  </blockquote>
                  <div className="mt-4 text-center">
                    <p className="font-semibold text-amber-900">— Ms Fortunate</p>
                    <p className="text-stone-600 text-sm">Founder & Lead Practitioner</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact-section" className="bg-amber-900 text-white py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <img 
                  src="https://static.readdy.ai/image/9173bb0b0f2f56000757a7cf45758267/1ea37a87bc1fe065fa3e33c05120ca7c.png" 
                  alt="CogniHeroes Academy Logo" 
                  className="h-8 w-8"
                />
                <h3 className="text-2xl font-bold" style={{ fontFamily: '"Playfair Display", serif' }}>
                  CogniHeroes Academy
                </h3>
              </div>
              <p className="text-orange-200 mb-8 leading-relaxed">
                Empowering every mind through inclusive education and specialized neurofeedback training.
              </p>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/share/1AX5Ghv27A/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-white text-lg"></i>
                </a>
                <a href="https://www.instagram.com/cogniheroesacademy?igsh=MWVkZzFneWJ0MndrYw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-white text-lg"></i>
                </a>
                <a href="https://www.tiktok.com/@cogniheroes.acade?_r=1&_t=ZS-91ObP0zBoT2" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer">
                  <i className="ri-tiktok-line text-white text-lg"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>Quick Links</h4>
              <ul className="space-y-3">
                <li><button onClick={scrollToAbout} className="text-orange-200 hover:text-white cursor-pointer transition-colors">About Us</button></li>
                <li><button onClick={scrollToTestimonials} className="text-orange-200 hover:text-white cursor-pointer transition-colors">Testimonials</button></li>
                <li><a href="/booking" className="text-orange-200 hover:text-white cursor-pointer transition-colors">Book Now</a></li>
                <li><button onClick={scrollToContact} className="text-orange-200 hover:text-white cursor-pointer transition-colors">Contact</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>Contact Info</h4>
              <div className="space-y-3 text-orange-200">
                <p className="flex items-center">
                  <i className="ri-map-pin-line mr-3"></i>
                  West Acres, Mbomela
                </p>
                <p className="flex items-center">
                  <i className="ri-mail-line mr-3"></i>
                  cogniheroesacademy@gmail.com
                </p>
                <p className="flex items-center">
                  <i className="ri-phone-line mr-3"></i>
                  +27 69 423 8367
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-orange-800 mt-16 pt-8">
            <p className="text-orange-200 text-sm text-center">
              © 2025 CogniHeroes Academy — Empowering Every Mind
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
